import type { Address } from "@/models/address"

export const formatAddress = (address: Address | undefined): string => {
  if (!address) {
    return ""
  }

  return [
    address.address_line_1,
    address.address_line_2,
    address.city,
    address.state,
    address.postal_code,
    address.country,
  ]
    .filter(Boolean)
    .join(", ")
}
